import { render } from "./Ediciones.vue?vue&type=template&id=1f59bbda"
import script from "./Ediciones.vue?vue&type=script&lang=js"
export * from "./Ediciones.vue?vue&type=script&lang=js"
script.render = render

export default script